import Vue from "vue";
import App from "./App.vue";
import "@/rem.js";
//所有注册的全局公共组件


Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
